import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgRssAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.25 2.24961C0 4.49883 0 8.11914 0 15.3602V16.6398C0 23.8809 0 27.5012 2.25 29.7504C4.49844 32 8.11875 32 15.3594 32H16.6406C23.8813 32 27.5016 32 29.75 29.7504C32 27.5012 32 23.8809 32 16.6398V15.3602C32 8.11914 32 4.49883 29.75 2.24961C27.5016 0 23.8813 0 16.6406 0H15.3594C8.11875 0 4.49844 0 2.25 2.24961ZM21.4039 24.9922C21.4039 17.0942 14.9058 10.5953 7.00781 10.5953V6.99609C16.8794 6.99609 25.0039 15.1206 25.0039 24.9922H21.4039ZM9.47553 20.054C10.8357 20.054 11.9447 21.163 11.9447 22.5247C11.9447 23.8842 10.8312 24.9917 9.46953 24.9917C8.11007 24.9917 7.00781 23.8864 7.00781 22.5247C7.00781 21.163 8.11382 20.0548 9.47553 20.054ZM18.937 24.9919H15.439C15.439 20.3661 11.6336 16.5599 7.00781 16.5599V13.062C13.5516 13.062 18.937 18.4488 18.937 24.9919Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRssAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
